import React from 'react';
import { createRoot } from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';

import { AppWithProviders } from 'app';
import { AuthService } from 'shared/lib/keycloak';
import { getDdRumConfig } from 'shared/config/dd-rum-config';
import { getEnv } from 'shared/config/constants';
import { fetchAmpConfig } from 'shared/config/amp-config';

async function main() {
  await fetchAmpConfig();
  await AuthService.init();

  if (getEnv() !== 'local') {
    datadogRum.init(getDdRumConfig());
  }

  const container = document.getElementById('root');
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = createRoot(container!);

  root.render(
    <React.StrictMode>
      <AppWithProviders />
    </React.StrictMode>,
  );
}

main();
